"use client";

import { useEffect, useState } from "react";

interface Stats {
  active_conversations: number;
  documents_indexed: number;
  content_sections: number;
  climate_goal: string;
  neutrality_goal: string;
}

export default function StatsBar() {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    fetch(`/api/portal/stats`)
      .then((r) => r.json())
      .then(setStats)
      .catch(() => {});
  }, []);

  if (!stats) return null;

  return (
    <div className="bg-green-900 text-white py-2 px-4">
      <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-6 text-sm">
        <span>💬 {stats.active_conversations} samtaler</span>
        <span>📄 {stats.documents_indexed} dokumenter</span>
        <span>🌿 Mål: {stats.climate_goal}</span>
        <span>🏆 {stats.neutrality_goal}</span>
      </div>
    </div>
  );
}
